import { Box } from "@mui/material";
import { ReactNode } from "react";

interface MdmTabPanelProps {
  children?: ReactNode;
  index: number;
  value: number;
}

export function MdmTabPanel({
  children,
  value,
  index,
  ...other
}: MdmTabPanelProps) {
  return (
    <div hidden={value !== index} id={`tabPanel-${index}`} {...other}>
      {value === index && <Box>{children}</Box>}
    </div>
  );
}
